import { getUrlParams } from 'core-components/helpers/url'

import { filterObject } from './filterObject'

export const getUrlParamsForDeleting = (url: string) => {
  const params = getUrlParams(url)
  return Object.keys(filterObject(params, ['page']))
}
